import { style } from '@/styles/globals';
import {
  Link, Typography, Box, Container, Grid, Divider, Stack,
} from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { styled } from '@mui/system';
import { pr } from '@/utils/pxToRem';
import { useEffect } from 'react';
import WrapperContainer from '@/components/WrapperContainer';
import { removeVietnameseTones, slugify } from '@/utils/stringConvert';
import GoyoloPartner from './GoyoloPartner';
import Certification from './Certification';
import SocialNetwork from './SocialNetwork';
import Applicaiton from './Applicaiton';
import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Image from 'next/image';
import { loaderImageVex } from '@/utils/loadImageSeoVex';
import { ILangObj } from '@/slices/goyoloSeo/sliceType';

export const BarWrapperDiv = styled('div')`
  display: flex;
  justify-content: center;
  width: 100%;
  background: ${style.color.white4};
  position:relative;
`;
const StyledFooter = styled('div')`
  bottom: 0;
  width: 100%;
  background: #F2F2F2;
`;
const StyledDiv = styled('div')`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: start;
`;
const StyledLowerDiv = styled('div')`
  text-align: center;
  justify-content: center;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  background: ${style.color.white2};
  width: ${pr`1152px`};
  flex-direction: column;
`;
const FullWidthDiv = styled(Box)`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 2em 0;
`;
const StyledVerticalDiv = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const StyledLink = styled(Link)`
  display: block;
  color: ${style.color.black2};
  text-decoration: none;
  margin-bottom: ${pr`8px`};
`;
const StyledIconLink = styled(Link)`
`;
const StyledTypography = styled(Typography)`
  color: ${style.color.black1};
  margin-bottom: 0.5em;
`;
const FooterWrapperDiv = styled(BarWrapperDiv)`
border-top: 1px solid ${style.color.black6};
`;

const StyleDivider = styled(Divider)`
  border: 1px solid ${style.color.black6};
  width: calc(100% + 48px);
  margin-left: -24px !important;
  border-bottom-width: 0;
  margin-top: 16px;
  margin-bottom: 16px;
`;

export const popularRoutes = [
  {
    from: {
      name: 'Nha Trang',
      slug: 'nha-trang',
      id: 417,
      stateName: 'Khánh Hòa',
    },
    to: {
      name: 'Sài Gòn',
      slug: 'sai-gon',
      id: 29,
      stateName: 'Sài Gòn',
    },
  },
  {
    from: {
      name: 'Hà Nội',
      slug: 'ha-noi',
      id: 24,
      stateName: 'Hà Nội',
    },
    to: {
      name: 'Sài Gòn',
      slug: 'sai-gon',
      id: 29,
      stateName: 'Sài Gòn',
    },
  },
  {
    from: {
      name: 'Sài Gòn',
      slug: 'sai-gon',
      id: 29,
      stateName: 'Sài Gòn',
    },
    to: {
      name: 'Nha Trang',
      slug: 'nha-trang',
      id: 417,
      stateName: 'Khánh Hòa',
    },
  },
  {
    from: {
      name: 'Sài Gòn',
      slug: 'sai-gon',
      id: 29,
      stateName: 'Sài Gòn',
    },
    to: {
      name: 'Hà Nội',
      slug: 'ha-noi',
      id: 24,
      stateName: 'Hà Nội',
    },
  },
  {
    from: {
      name: 'Đà Lạt',
      slug: 'da-lat',
      id: 457,
      stateName: 'Lâm Đồng',
    },
    to: {
      name: 'Sài Gòn',
      slug: 'sai-gon',
      id: 29,
      stateName: 'Sài Gòn',
    },
  },
  {
    from: {
      name: 'Sài Gòn',
      slug: 'sai-gon',
      id: 29,
      stateName: 'Sài Gòn',
    },
    to: {
      name: 'Đà Nẵng',
      slug: 'da-nang',
      id: 15,
      stateName: 'Đà Nẵng',
    },
  },
  {
    from: {
      name: 'Đà Nẵng',
      slug: 'da-nang',
      id: 15,
      stateName: 'Đà Nẵng',
    },
    to: {
      name: 'Sài Gòn',
      slug: 'sai-gon',
      id: 29,
      stateName: 'Sài Gòn',
    },
  },
  {
    from: {
      name: 'Sài Gòn',
      slug: 'sai-gon',
      id: 29,
      stateName: 'Sài Gòn',
    },
    to: {
      name: 'Đà Lạt',
      slug: 'da-lat',
      id: 457,
      stateName: 'Lâm Đồng',
    },
  },
  {
    from: {
      name: 'Sài Gòn',
      slug: 'sai-gon',
      id: 29,
      stateName: 'Sài Gòn',
    },
    to: {
      name: 'Buôn Ma Thuột',
      slug: 'buon-ma-thuot-dak-lak',
      id: 204,
      stateName: 'Buôn Ma Thuột',
    },
  },
  {
    from: {
      name: 'Sài Gòn',
      slug: 'sai-gon',
      id: 29,
      stateName: 'Sài Gòn',
    },
    to: {
      name: 'Pleiku',
      slug: 'pleiku-gia-lai',
      id: 274,
      stateName: 'Gia Lai',
    },
  },
];

export const popularPoint = [
  {
    to: {
      name: 'Sài Gòn',
      slug: 'sai-gon',
      id: 29,
      stateName: 'Sài Gòn',
    },
  },
  {
    to: {
      name: 'Hà Nội',
      slug: 'ha-noi',
      id: 24,
      stateName: 'Hà Nội',
    },
  },
  {

    to: {
      name: 'Nha Trang',
      slug: 'nha-trang',
      id: 417,
      stateName: 'Khánh Hòa',
    },
  },
  {

    to: {
      name: 'Đà Nẵng',
      slug: 'da-nang',
      id: 15,
      stateName: 'Đà Nẵng',
    },
  },
  {

    to: {
      name: 'Đà Lạt',
      slug: 'da-lat',
      id: 457,
      stateName: 'Lâm Đồng',
    },
  },
  {

    to: {
      name: 'Buôn Ma Thuột',
      slug: 'buon-ma-thuot-dak-lak',
      id: 204,
      stateName: 'Buôn Ma Thuột',
    },
  },
  {

    to: {
      name: 'Pleiku',
      slug: 'pleiku-gia-lai',
      id: 274,
      stateName: 'Gia Lai',
    },
  },
  {

    to: {
      name: 'Quy Nhơn',
      slug: 'quy-nhon-binh-dinh',
      id: 131,
      stateName: 'Bình Định',
    },
  },
  {

    to: {
      name: 'Phú Quốc',
      slug: 'phu-quoc',
      id: 431,
      stateName: 'Kiên Giang',
    },
  },
  {

    to: {
      name: 'Huế',
      slug: 'hue',
      id: 705,
      stateName: 'Thừa Thiên Huế',
    },
  },
];

export const popularAirlines = [
  {
    name: 'Vietnam Airlines',
    slug: 'vietnam-airlines',
  },
  {
    name: 'Vietjet Air',
    slug: 'vietjet-air',
  },
  {
    name: 'Bamboo Airways',
    slug: 'bamboo-airways',
  },
  {
    name: 'Vietravel Airlines',
    slug: 'vietravel-airlines',
  },
  {
    name: 'Pacific Airlines',
    slug: 'pacific-airlines',
  },
];

export const popularAirports = [
  {
    name: 'Sân bay quốc tế Tân Sơn Nhất',
    nameEn: 'Tan Son Nhat International Airport',
  },
  {
    name: 'Sân bay quốc tế Nội Bài',
    nameEn: 'Noi Bai International Airport',
  },
  {
    name: 'Sân bay quốc tế Đà Nẵng',
    nameEn: 'Da Nang International Airport',
  },
  {
    name: 'Sân bay quốc tế Cam Ranh',
    nameEn: 'Cam Ranh International Airport',
  },
  {
    name: 'Sân bay Buôn Ma Thuột',
    nameEn: 'Buon Ma Thuot airport',
  },
  {
    name: 'Sân bay quốc tế Liên Khương',
    nameEn: 'Lien Khuong International airport',
  },
  {
    name: 'Sân bay Pleiku',
    nameEn: 'Pleiku airport',
  },
  {
    name: 'Sân bay quốc tế Phú Quốc',
    nameEn: 'Phu Quoc International airport ',
  },
  {
    name: 'Sân bay quốc tế Vinh',
    nameEn: 'Vinh International airport ',
  },
  {
    name: 'Sân bay quốc tế Phú Bài',
    nameEn: 'Phu Bai International airport',
  },
];

const aboutUs = [
  {
    name: 'Giới thiệu VeXeRe',
    slugDirect: 'https://vexere.com/vi-VN/gioi-thieu.html',
  },
  {
    name: 'Tuyển dụng',
    slugDirect: 'https://careers.vexere.com/',
  },
  {
    name: 'Tin tức',
    slugDirect: 'https://blog.vexere.com/',
  },
  {
    name: 'Liên hệ',
    slugDirect: 'https://vexere.com/vi-VN/lien-he.html',
  },
];
const product = [
  {
    name: 'Đặt vé xe khách',
    slugDirect: 'https://vexere.com/',
  },
  {
    name: 'Đặt vé máy bay',
    slugDirect: 'https://vexere.com/vn/ve-may-bay.vi',
  },
  {
    name: 'Đặt vé tàu hỏa',
    slugDirect: 'https://vexere.com/vn/ve-tau-hoa.vi',
  },
  {
    name: 'Đặt vé tàu thủy',
    slugDirect: 'https://goyolo.com/',
  },
  {
    name: 'Thuê xe',
    slugDirect: 'https://thuexe.vexere.com/vn/thue-xe/',
  },
];

const productBB = [
  {
    name: 'Mở bán tại Vexere',
    slugDirect: 'https://bms.vexere.com/mo-ban-ve-tren-vexere-com?utm_source=vex&utm_medium=header&utme_campaign=referral',
  },
  {
    name: 'Phần mềm nhà xe',
    slugDirect: 'https://bms.vexere.com/phan-mem-nha-xe',
  },
  {
    name: 'Phần mềm đại lý',
    slugDirect: 'https://daily.vexere.com/',
  },
];

interface GoyoloLinksItemProps {
  title?: string;
  listData?: any;
  type?: 'route' | 'point' | 'airline' | 'airport' | 'aboutUs' | 'product' | 'productBB';
  hideLabel?: boolean;
  lang?: ILangObj;
}
const GoyoloLinksItem: React.FC<GoyoloLinksItemProps> = ({
  title,
  listData,
  type,
  hideLabel,
  lang,
}) => (
  <Stack
    spacing={pr`16px`}
    sx={{
      minWidth: '277px',
      marginRight: '16px',
    }}
  >
    {!hideLabel && (
      <Typography
        variant="title"
        component="div"
        fontWeight="700"
        sx={{
          color: style.neutral.dark,
          fontWeight: 700,
          fontSize: '18px',
          lineHeight: '30px',
        }}
      >
        {title}
      </Typography>
    )}
    <Stack spacing={pr`12px`}>
      {(listData || []).map((data: any) => {
        let label = '';
        let url = '';
        const preSlug = lang?.lang === 'en' ? 'flights' : 've-may-bay';
        const fromSlug = lang?.lang === 'en' ? 'from' : 'tu';
        const toSlug = lang?.lang === 'en' ? 'to' : 'di';
        const extLang = lang?.lang === 'en' ? 'en' : 'vi';
        switch (type) {
          case 'route':
            label = `${lang?.global?.airlineTicketText || 'Vé Máy bay'} ${lang?.global?.from?.toLocaleLowerCase() || 'từ'} ${lang?.lang === 'en' ? removeVietnameseTones(data.from.name) : data.from.name} ${lang?.global?.to?.toLocaleLowerCase() || 'đi'} ${lang?.lang === 'en' ? removeVietnameseTones(data.to.name) : data.to.name}`;
            url = `/vn/${preSlug}/${fromSlug}-${data.from.slug}${data.from?.slug !== slugify(data.from?.stateName) ? `-${slugify(data.from?.stateName)}` : ''}-${toSlug}-${data.to.slug}${data.to?.slug !== slugify(data.to?.stateName) ? `-${slugify(data.to?.stateName)}` : ''}.${data.from.id}.${data.to.id}.${extLang}`;
            break;
          case 'point':
            label = `${lang?.global?.airlineTicketText || 'Vé Máy bay'} ${lang?.global?.to?.toLocaleLowerCase() || 'đi'} ${lang?.lang === 'en' ? removeVietnameseTones(data.to.name) : data.to.name}`;
            url = `/vn/${preSlug}/${toSlug}-${data.to.slug}${data.to?.slug !== slugify(data.to?.stateName) ? `-${slugify(data.to?.stateName)}` : ''}.${data.to.id}.${extLang}`;
            break;
          case 'airline':
            label = data.name;
            url = `/vn/${preSlug}/${data.slug}.${extLang}`;
            break;
          case 'airport':
            label = lang?.lang === 'en' ? data.nameEn : data.name;
            url = `/vn/${preSlug}/${slugify(label)}.${extLang}`;
            break;
          case 'aboutUs':
            label = data.name;
            url = data.slugDirect;
            break;
          case 'product':
            label = data.name;
            url = data.slugDirect;
            break;
          case 'productBB':
            label = data.name;
            url = data.slugDirect;
            break;
          default:
            break;
        }
        return (
          <Link
            sx={{
              textDecoration: 'none',
              fontWeight: 500,
              fontSize: '14px',
              lineHeight: '20px',
              color: style.neutral.dark,
            }}
            key={label}
            href={url}
            target="_blank"
          >
            {label}
          </Link>
        );
      })}
    </Stack>
  </Stack>
);

const FooterBar = ({ ismobile, lang }: { ismobile?: boolean, lang?: ILangObj }) => {
  useEffect(() => {
    document.body.style.background = style.color.white2;
    return () => { document.body.style.background = ''; };
  }, []);

  return (
    <StyledFooter>
      <Container
        maxWidth="maxWidth"
        sx={{
          padding: ismobile ? '0px 16px' : '40px 230px',
        }}
      >
        <Stack
          direction="row"
          sx={{
            overflow: 'auto',
          }}
        >
          <GoyoloLinksItem
            type="route"
            title={lang?.footer?.routes}
            lang={lang}
            listData={popularRoutes}
          />
          <GoyoloLinksItem
            type="point"
            title={lang?.footer?.popularDestionations}
            listData={popularPoint}
            lang={lang}
          />
          <GoyoloLinksItem
            type="airline"
            title={lang?.footer?.popularAirlines}
            listData={popularAirlines}
            lang={lang}
          />
          <GoyoloLinksItem
            type="airport"
            title={lang?.footer?.popularAirports}
            listData={popularAirports}
            lang={lang}
          />
        </Stack>
        <StyleDivider />
        <div style={{
          marginBottom: '16px',
        }}
        >
          <Accordion sx={{
            boxShadow: 'none',
            borderBottom: '1px solid #E0E0E0',
            background: '#F2F2F2',
          }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              sx={{
                padding: '0px',
              }}
            >
              <Typography sx={{
                fontWeight: '700',
                fontSize: '18px',
                lineHeight: '30px',
                color: `${style.color.black1}`,
              }}
              >
                {lang?.footer?.aboutUs?.title || 'Về chúng tôi'}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <GoyoloLinksItem
                type="aboutUs"
                title="Về chúng tôi"
                listData={lang?.footer?.aboutUs?.children}
                hideLabel
              />
              {/* <GoyoloPartner /> */}
            </AccordionDetails>
          </Accordion>
          <Accordion sx={{
            boxShadow: 'none',
            borderBottom: '1px solid #E0E0E0',
            padding: '0px',
            background: '#F2F2F2',
          }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2a-content"
              id="panel2a-header"
              sx={{
                padding: '0px',
              }}
            >
              <Typography sx={{
                fontWeight: '700',
                fontSize: '18px',
                lineHeight: '30px',
                color: `${style.color.black1}`,
              }}
              >
                {lang?.footer?.products?.title || 'Sản phẩm'}

              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <GoyoloLinksItem
                hideLabel
                type="product"
                title="Sản phẩm"
                listData={lang?.footer?.products?.children}
              />
            </AccordionDetails>
          </Accordion>
          <Accordion sx={{
            boxShadow: 'none',
            borderBottom: '1px solid #E0E0E0',
            padding: '0px',
            background: '#F2F2F2',
          }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2a-content"
              id="panel2a-header"
              sx={{
                padding: '0px',
              }}
            >
              <Typography sx={{
                fontWeight: '700',
                fontSize: '18px',
                lineHeight: '30px',
                color: `${style.color.black1}`,
              }}
              >
                {lang?.footer?.productsOperators?.title || 'Sản phẩm dành cho nhà xe'}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <GoyoloLinksItem
                hideLabel
                type="productBB"
                title="Sản phẩm dành cho nhà xe"
                listData={lang?.footer?.productsOperators?.children}
              />
            </AccordionDetails>
          </Accordion>
        </div>
        <GoyoloPartner lang={lang} />
        <StyleDivider />
        <Certification lang={lang} />
        <StyleDivider />
        <SocialNetwork lang={lang} />
        <StyleDivider />
        <Applicaiton lang={lang} />
      </Container>
      <FullWidthDiv sx={{
        width: '100%',
        background: style.neutral.black,
        marginTop: '40px',
      }}
      >
        <div style={{
          padding: '0 16px',
          background: style.neutral.black,
          color: '#B8B8B8',
        }}
        >
          <Typography
            // component="h1"
            sx={{
              color: 'white',
              fontWeight: 700,
              fontSize: '18px',
              lineHeight: '24px',
              letterSpacing: '-0.25px',
            }}
          >
            {lang?.footer?.slogan}
          </Typography>
          <Grid
            container
            sx={{
              marginTop: '8px',
            }}
          >
            <Grid
              item
              xs={6}
            >
              <Stack
                justifyContent="center"
                alignItems="center"
              >
                <a href="http://online.gov.vn/Home/AppDetails/462">
                  <Image
                    loader={loaderImageVex}
                    src="https://storage.googleapis.com/goyolo-uat/images/SeoVexImprove/Certification/mobile1.svg"
                    alt="logo"
                    width="150px"
                    height="72px"
                    objectFit="contain"
                  />
                </a>
              </Stack>
            </Grid>
            <Grid
              item
              xs={6}
            >
              <Stack
                justifyContent="center"
                alignItems="center"
              >
                <a href="http://online.gov.vn/Home/WebDetails/70277">
                  <Image
                    loader={loaderImageVex}
                    src="https://storage.googleapis.com/goyolo-uat/images/SeoVexImprove/Certification/mobile2.svg"
                    alt="logo"
                    width="150px"
                    height="72px"
                    objectFit="contain"
                  />
                </a>
              </Stack>
            </Grid>
          </Grid>
          <Typography sx={{
            color: 'white',
            fontWeight: 500,
            fontSize: '14px',
            lineHeight: '20px',
            textAlign: 'center',
          }}
          >
            {lang?.footer?.company || 'Công ty TNHH Thương Mại Dịch Vụ VeXeRe'}
          </Typography>
          <div style={{
            fontWeight: 400,
            fontSize: '12px',
            lineHeight: '16px',
            textAlign: 'center',
            color: '#B8B8B8',
          }}
          >
            {lang?.footer?.registeredAddress || 'Địa chỉ đăng ký kinh doanh: 8C Chữ Đồng Tử, Phường 7, Quận Tân Bình, Thành Phố Hồ Chí Minh, Việt Nam'}
            <br />
            {lang?.footer?.address || 'Địa chỉ: '}
            <a
              style={{
                display: 'contents',
                textDecoration: 'none',
                color: '#B8B8B8',
              }}
              href="https://www.google.com/maps/place/CirCO+Dien+Bien+Phu/@10.7822282,106.6880465,18z/data=!3m1!4b1!4m13!1m7!3m6!1s0x31752f31c5edc5a3:0xe8f6cfd8e118c28c!2zMjIyIMSQaeG7h24gQmnDqm4gUGjhu6csIFBoxrDhu51uZyA3LCBRdeG6rW4gMywgSOG7kyBDaMOtIE1pbmgsIFZpZXRuYW0!3b1!8m2!3d10.7822256!4d106.6891435!3m4!1s0x31752f9514a4a77f:0xb0d51eeba4261070!8m2!3d10.7822256!4d106.6891435?hl=en-US"
            >
              {lang?.footer?.contactAddress || 'Địa chỉ: Lầu 8, Tòa nhà CirCO, 222 Điện Biên Phủ, Quận 3, TP. Hồ Chí Minh, Việt Nam'}

            </a>
            <br />
            {lang?.footer?.businessRegistration || 'Giấy chứng nhận ĐKKD số 0315133726 do Sở KH và ĐT TP. Hồ Chí Minh cấp lần đầu ngày 27/6/2018'}
            <br />
            {lang?.footer?.copyright || 'Bản quyền © 2022 thuộc về VeXeRe.Com'}
            <br />
          </div>
        </div>
      </FullWidthDiv>
    </StyledFooter>
  );
};

export default FooterBar;
